import React from "react";
import { Trophy } from "lucide-react";

import { Button } from "../ui/button";

// The number of entries the "Top 5" view of a cloud keeps.
export const TOP_COUNT = 5;

interface TopFiveButtonProps {
  // What is being ranked, e.g. "Authors" -> "Top 5 Authors".
  noun: string;
  active: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

// Toggle for the author/tag cloud pages: on, the cloud shows only its top
// entries for the selected category; off, every entry. Same pill as Share.
export function TopFiveButton({ noun, active, onToggle, disabled }: TopFiveButtonProps) {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onToggle}
      disabled={disabled}
      aria-pressed={active}
      title={active ? `Showing the top ${TOP_COUNT} - tap to show all` : `Show only the top ${TOP_COUNT}`}
      className={`flex items-center gap-1.5 shrink-0 rounded-full whitespace-nowrap px-3.5 transition-all duration-200 ${
        active
          ? "bg-slate-900 text-white hover:bg-slate-800 hover:text-white dark:bg-white dark:text-slate-900 dark:hover:bg-slate-200 dark:hover:text-slate-900"
          : "bg-slate-100 text-slate-600 hover:bg-slate-200 hover:text-slate-600 dark:bg-slate-800/80 dark:text-slate-300 dark:hover:bg-slate-700 dark:hover:text-slate-300"
      }`}
    >
      <Trophy className="w-3.5 h-3.5" />
      <span className="text-xs font-medium">
        Top {TOP_COUNT} {noun}
      </span>
    </Button>
  );
}
